import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, TextField, InputAdornment, IconButton, Button, Alert, Tooltip,
} from '@mui/material';
import { VpnKey, ContentCopy, Check } from '@mui/icons-material';

export default function TempPasswordDialog({ open, userName, temporaryPassword, onClose }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(temporaryPassword || '');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard unavailable — user can still select+copy the field manually
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <VpnKey color="primary" />
        <Typography variant="h6" fontWeight={700}>Temporary Password</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Shown once — relay this to <strong>{userName}</strong> securely. They will be
          required to set a new password on their next login.
        </Alert>
        <TextField
          label="Temporary Password" value={temporaryPassword || ''} fullWidth size="small"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title={copied ? 'Copied' : 'Copy'}>
                  <IconButton size="small" onClick={handleCopy}>
                    {copied ? <Check fontSize="small" color="success" /> : <ContentCopy fontSize="small" />}
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" onClick={onClose}>Done</Button>
      </DialogActions>
    </Dialog>
  );
}
